// extracted by mini-css-extract-plugin
export var chevron = "_36-2";
export var chevronCollapsed = "_36-3";
export var collapsibleHeader = "_36-1";
export var container = "_36-0";